import { Arg } from './builder/args';
import { Metadata } from './builder/metadata';

// Re-export from submodules
export { Arg, ArgTypes } from './builder/args';
export {
  applyDeprecatedDescriptionPrefix,
  DEPRECATED_DESCRIPTION_PREFIX,
  pick,
  pickAll,
  sortAndStampMeta,
  sortKeys,
} from './builder/helpers';
export { Metadata } from './builder/metadata';
export { defaultDeprecationArgumentId, warnDeprecatedArguments } from './deprecated-args';

// Default export for backwards compatibility
export default { Arg, Metadata };
